const holder = {
  closeInputSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ displayInput: false, inputValue: null });
      document.removeEventListener("mousedown", holder.closeInputSelector)
    }
  }
};

export default {
  'TipButtons.Wrapper.Button': ({ tab }, outlet) => {
    outlet({ value: tab.tip })
  },
  'TipButtons.Wrapper.Other': async ({ containerRef }, outlet, internalStateSetter) => {
    await internalStateSetter({ displayInput: true });
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    holder.outlet = outlet;
    document.addEventListener("mousedown", holder.closeInputSelector);

    //focus input. Need await on internalStateSetter to focus after we change the displayed elements.
    containerRef?.current?.childNodes?.[0]?.childNodes?.[1]?.childNodes?.[0]?.focus();
  },
  'TipButtons.Wrapper.Other.InputWrapper.Input(Keydown)': () => {
  },
  'TipButtons.Wrapper.Other.InputWrapper.Input': ({ value }, outlet, internalStateSetter) => {
    let number = parseInt(value);
    if (isNaN(number)) {
      internalStateSetter({ inputValue: null });
      outlet({ value: null })
    } else {
      internalStateSetter({ inputValue: number });
      outlet({ value: number })
    }
  }
}
